import { baseTemplateConfigSchema, baseTemplateLocationItemSchema, baseTemplateLocationSchema } from "@anggunpraya-templates/base/app/schemas/template";
import { z } from "zod";

export const templateConfigSchema = baseTemplateConfigSchema.extend({
  location: baseTemplateLocationSchema.extend({
    items: z.array(
      baseTemplateLocationItemSchema.extend({
        maps_embed_link: z.url(),
      }),
    ),
  }),
});

export type TemplateConfig = z.infer<typeof templateConfigSchema>;

export function defineAp004TemplateConfig<TConfig extends TemplateConfig>(config: TConfig) {
  return templateConfigSchema.parse(config) as TConfig;
}
